
export function toggleBooleanAttribute( attr, el ) {
    el.setAttribute( attr, el.getAttribute( attr ) === "true" ? "false" : "true" );
}

export function is_attr(attr, el) {
    return el.getAttribute( attr ) === "true" ? true : false;
}